import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { SchedulerComponent } from './components/scheduler/scheduler.component';
import { ScreenBuilderComponent } from './components/screen-builder/screen-builder.component';
import { AuthGuard } from './guards';
import { PopupComponent } from './components/popup/popup.component';
import { SigninComponent } from './components/signin/signin.component';

const routes: Routes = [
  { path: '', component: ScreenBuilderComponent, canActivate: [AuthGuard] },
  { path: 'home', component: ScreenBuilderComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'login/:username', component: LoginComponent },
  { path: 'signin', component: SigninComponent },
  { path: 'scheduler', component: SchedulerComponent },
  { path: 'popup', component: PopupComponent },
  { path: 'new-account', component: LoginComponent },
  { path: 'mp-video', component: LoginComponent },
  { path: 'sb-video', component: LoginComponent },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts